import { createContext, useContext, useState, ReactNode } from "react";

interface UIContextType {
  formData: Record<string, string>;
  setFieldValue: (fieldId: string, value: string) => void;
  getFieldValue: (fieldId: string) => string;
  resetForm: () => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

interface UIProviderProps {
  children: ReactNode;
  initialData?: Record<string, string>;
}

export function UIProvider({ children, initialData = {} }: UIProviderProps) {
  const [formData, setFormData] = useState<Record<string, string>>(initialData);

  const setFieldValue = (fieldId: string, value: string) => {
    setFormData((prev) => ({ ...prev, [fieldId]: value }));
  };

  const getFieldValue = (fieldId: string) => {
    return formData[fieldId] || "";
  };

  const resetForm = () => {
    setFormData(initialData);
  };

  return (
    <UIContext.Provider
      value={{ formData, setFieldValue, getFieldValue, resetForm }}
    >
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUI must be used within UIProvider");
  }
  return context;
}
